/* eslint-disable prefer-arrow-callback */
const scrollState = function scrollState() {
  const scrolls = document.querySelectorAll('[data-scroll-state]');

  scrolls.forEach((element) => {
    const updateScroll = function updateScroll() {
      const scrollPos = element.scrollTop;
      const scrollHeight = element.scrollHeight - element.offsetHeight;

      if (scrollPos > 0) {
        element.classList.add('scroll-top');
      } else {
        element.classList.remove('scroll-top');
      }

      if (scrollPos < scrollHeight) {
        element.classList.add('scroll-bottom');
      } else {
        element.classList.remove('scroll-bottom');
      }
    };

    element.addEventListener('scroll', updateScroll);
    window.addEventListener('resize', updateScroll);
    window.addEventListener('orientationchange', updateScroll);
    updateScroll();
  });
};

exports.default = scrollState;
